import React from 'react';
import BradescoFooter from './BradescoFooter';
import styled from 'styled-components'

// imgs
import imgLogoBellinati from '../../images/logo-bellinati-footer.svg'
import imgCadeadoFechado from '../../images/cadeado-fechado.svg'
import imgGloboVirtual from '../../images/footer-globo-virtual.svg'
import imgInstagram from '../../images/footer-instagram.svg'
import imgFacebook from '../../images/footer-facebook.svg'
import imgLinkedin from '../../images/footer-linkedin.svg'

import googleSafeBrowsing from '../../images/google-safe-browsing.svg'
import seloGptw from '../../images/Selo-GPTW.svg'
import iso9001 from '../../images/Selo-iso-9001.svg'
import iso27001 from '../../images/Selo-iso-27001.svg'
import iso27701 from '../../images/Selo-iso-27701.svg'

const isoImages = {
	googleSafeBrowsing,
	seloGptw,
	iso9001,
	iso27001,
	iso27701
}

const FooterStyled = styled.footer`
	display: flex;
	flex-direction: row;

  * {
    margin: 0;
    padding: 0;
  }

	color: #FFF;

	background-color: #111;
	width: 100%;
	padding: 2.5rem 7rem;
	justify-content: space-between;
	align-items: center;
	gap: 1.25rem;

	.logoEContato {
		display: flex;
		flex-direction: row;
		gap: 1.875rem;
		align-items: left;
	}

	@media screen and (max-width: 1080px) {
		padding: 1.875rem 1.25rem;
		justify-content: space-around;
	}

	@media screen and (max-width: 900px) {
		flex-direction: column;
		justify-content: center;
	}

	transition: all 0.3s;
`

const LogoBellinati = styled.img`
	height: 3.125rem;

	@media screen and (max-width: 1080px) {
		flex-direction: column;
		justify-content: center;
	}

	transition: all 0.3s;
`

const Contato = styled.div`
	ul {
		list-style: none;
		display: flex;
		flex-direction: column;
	}

	font-size: 0.75rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1 rem;

	@media screen and (max-width: 900px) {
		text-align: right;
	}

	transition: all 0.3s;
`

const AtendimentoSeguro = styled.div`
	list-style: none;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.625rem;

	span {
		display: flex;
		align-items: center;
		justify-content: center;
		
		height: 1.875rem;
		width: 1.875rem;
	}

	.textoAtendimentoSeguro {
		font-size: 0.75rem;
		font-weight: 400;
		line-height: 1rem;
		max-width: 15.0800rem;

		strong {
			font-size: 12px;
			font-weight: 700;
		}
	}
`

const RedesSociais = styled.div` 
	ul {
		list-style: none;
		display: flex;
		flex-direction: row;
		gap: 0.625rem;
	}

	a {
		img {
			height: 1rem;
			width: 1rem;
		}

		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFF;
		border-radius: 50%;
		height: 2rem;
		width: 2rem;
	}
`

const SectionIsoCertifications = styled.section`
	/* layout */
	padding: 1.25rem 7rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	/* style */
	background-color: #FFF;

	/* responsive */
	@media screen and (max-width: 1050px) {
		padding: 1.25rem 5rem;
	}
	
	@media screen and (max-width: 950px) {
		flex-direction: column-reverse;
		justify-content: center;
		align-items: center;
		gap: 1.25rem;
	}

	transition: all 0.3s;

	@media screen and (max-width: 768px){
		padding: 1.25rem;
	}
`;

const PoliticaDePrivacidade = styled.div`
	color: #111;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: left;

	p {
		font-size: 0.6875rem;
		font-weight: 400;
	}

	a {
		color: #A82047;
		text-decoration: underline;
		font-size: 0.6875rem;
		font-weight: 400;
	}

	@media screen and (max-width: 950px) {
		text-align: center;
	}
`;

const Selos = styled.div`
	display: flex;
	flex-direction: row; 
	justify-content: left;
	align-items: center;

	gap: 0.625rem;

	@media screen and (max-width: 950px) {
		display: flex;
		flex-direction: row;
	}

	@media screen and (max-width: 768px) {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
`;

export default function Footer() {
  const FINANCEIRA = process.env.REACT_APP_FINANCEIRA;

  return (
    <>
      {
        FINANCEIRA === 'bradesco' ?
          (
            <BradescoFooter />
          )
          :
          (
            <>
              <FooterStyled>

                <div className='logoEContato'>
                  <LogoBellinati src={imgLogoBellinati} alt='Logo da Bellinati Perez.'>
                  </LogoBellinati>

                  <Contato>
                    <ul>
                      <li>CNPJ 13.600.461/0001-47</li>
                      <li>R. Alfredo Bufren, 155</li>
                      <li>Centro, Curitiba - PR</li>
                      <li>CEP 80020-240</li>
                    </ul>
                  </Contato>
                </div>

                <AtendimentoSeguro>
                  <span>
                    <img src={imgCadeadoFechado} alt="Imagem de cadeado fechado" />
                  </span>
                  <div className='textoAtendimentoSeguro'>
                    Nosso atendimento é totalmente online e nosso ambiente digital é <strong>100% seguro</strong>.
                  </div>
                </AtendimentoSeguro>

                <RedesSociais>
                  <ul>
                    <li>
                      <a target='_blank' href="https://www.bellinatiperez.com.br/">
                        <img src={imgGloboVirtual} alt="Icone de globo virtual" />
                      </a>
                    </li>
                    <li>
                      <a target='_blank' href="https://www.instagram.com/bellinatiperez">
                        <img src={imgInstagram} alt="Icone do Instagram" />
                      </a>
                    </li>
                    <li>
                      <a target='_blank' href="https://www.facebook.com/bellinatiperez">
                        <img src={imgFacebook} alt="Icone do Facebook" />
                      </a>
                    </li>
                    <li>
                      <a target='_blank' href="https://www.linkedin.com/company/bellinati-perez">
                        <img src={imgLinkedin} alt="Icone do Linkedin" />
                      </a>
                    </li>
                  </ul>
                </RedesSociais>
              </FooterStyled>

              <SectionIsoCertifications>
                <PoliticaDePrivacidade>
                  <p>Todos os direitos reservados © 2024</p>
                  <a target='_blank' href="/assets/files/BP01.11 - Política de Privacidade e Dados.pdf">Política de Privacidade</a>
                </PoliticaDePrivacidade>

                <Selos>
                  <a target='_blank' href="https://transparencyreport.google.com/safe-browsing/search?url=https:%2F%2Fbradesco.bp.com.vc%2Flogin">
                    <img src={isoImages.googleSafeBrowsing} />
                  </a>
                  <a target='_blank' href="https://certificadas.gptw.com.br/03404018004568">
                    <img src={isoImages.seloGptw} />
                  </a>
                  <a target='_blank' href="https://www.iso.org/standard/62085.html">
                    <img src={isoImages.iso9001} />
                  </a>
                  <a target='_blank' href="https://www.iso.org/standard/27001">
                    <img src={isoImages.iso27001} />
                  </a>
                  <a target='_blank' href="https://www.iso.org/standard/71670.html">
                    <img src={isoImages.iso27701} />
                  </a>
                </Selos>
              </SectionIsoCertifications>
            </>
          )
      }
    </>
  );
}